import { Pointer } from "lucide-react";
import React from "react";
import { Cursor } from "react-bootstrap-icons";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css"; // Import carousel styles
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import usePermissions from "./hooks/usePermissions";
import { PERMISSIONS } from "./constants/permissions";

export default function ReportsCarousel() {
  const navigate = useNavigate();
  const { has: hasPermission } = usePermissions();
  const canStartAssessment = hasPermission(PERMISSIONS.START_ASSESSMENTS);
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  const handleCSRD = () => {
    localStorage.removeItem("report_name");
    navigate("/csrd");
  };

  const handleBRSR = () => {
    localStorage.removeItem("report_name");
    navigate("/brsr/new-report");
  };

  return (
    <div className="standards-container">
      <Carousel
        responsive={responsive}
        itemClass="carousel-item-padding"
        // customPrevArrow={<CustomPrevArrow />}
        // customNextArrow={<CustomNextArrow />}
      >
        <a className="other-image">
          <div>
            <img src="/assets/img/reports/gri.png" className="wd-50" alt="Image 1" />
            <div className="image-overlay"></div>
          </div>
        </a>

        {/* <a href="/csrd" className="csrd-image">
          <div>
            <img src="./assets\img\reports\report-02.png" className="wd-50" alt="Image 2" />
          </div>
        </a> */}

        <Tooltip title={canStartAssessment ? "" : "You don't have permission to start a report"} arrow>
        <div className="report-image-clickable" style={{ cursor: canStartAssessment ? "pointer" : "not-allowed", opacity: canStartAssessment ? 1 : 0.45 }} onClick={canStartAssessment ? handleCSRD : undefined}>
          <div className="report-image-border-wrapper">
            <div className="report-image-wrapper">
              <img src="/assets/img/reports/csrd.png" className="wd-50" alt="CSRD Report" />
            </div>
          </div>
        </div>
        </Tooltip>

        <Tooltip title={canStartAssessment ? "" : "You don't have permission to start a report"} arrow>
        <div className="report-image-clickable" style={{ cursor: canStartAssessment ? "pointer" : "not-allowed", opacity: canStartAssessment ? 1 : 0.45 }} onClick={canStartAssessment ? handleBRSR : undefined}>
          <div className="report-image-border-wrapper">
            <div className="report-image-wrapper">
              <img src="/assets/img/reports/brsr.webp" className="wd-50" alt="BRSR Report" />
            </div>
          </div>
        </div>
        </Tooltip>

        {/* <a className="other-image">
          <div>
            <img src="/assets/img/reports/report-03.png" className="wd-50" alt="Image 3" />
            <div className="image-overlay"></div>
          </div>
        </a> */}

        <a className="other-image">
          <div>
            <img src="/assets/img/reports/ifrs.png" className="wd-50" alt="Image 4" />
            <div className="image-overlay"></div>
          </div>
        </a>

        <a className="other-image">
          <div>
            <img src="/assets/img/reports/tcfd.png" className="wd-50" alt="Image 5" />
            <div className="image-overlay"></div>
          </div>
        </a>
      </Carousel>
    </div>
  );
}

// const CustomPrevArrow = ({ onClick }) => (
//   <button onClick={onClick} className="custom-arrow prev-arrow">
//     &lt; {/* Use your custom arrow icon or text */}
//   </button>
// );

// const CustomNextArrow = ({ onClick }) => (
//   <button onClick={onClick} className="custom-arrow next-arrow">
//     &gt; {/* Use your custom arrow icon or text */}
//   </button>
// );
